import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { LocationProvider } from './contexts/LocationContext';
import LocationModal from './components/LocationModal';
import AppRoutes from './routes';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      main: '#5F3C6F',
      light: '#D558B6',
      dark: '#c62828',
    },
    secondary: {
      main: '#757575',
      light: '#9e9e9e',
      dark: '#616161',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },

  },
});

const App: React.FC = () => {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider>
          <AuthProvider>
            <LocationProvider>
              <Box width="100vw" overflow="hidden">
                <LocationModal />
                <AppRoutes />
                <Footer />
              </Box>
            </LocationProvider>
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
